export enum supplyClassificationEnum {
  成衣 = 1,
  面料 = 2,
  辅料 = 3,
  耗材 = 4,
  特殊工艺 = 5,
}
